<template>
    <div class="two-text-fields-with-symbols-version2">
        <label v-show="toggleLabel" :for="name" v-bind:style="{fontWeight: fontWeight }">{{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>

        <div id="two-inputs">
            <div class="input-group mb-3 input-two">
                <input ref="text-field-input-two" type="text" v-model="valueTwo" v-on:blur="focusOutTwo" v-on:focus="saveCurrentValueTwo" v-on:change="validateValueTwo" class="form-control text-field-input smaller-input" :placeholder="placeholderTwo" :aria-label="placeholderTwo" aria-describedby="basic-addon2">
                <div class="input-group-append">
                    <span class="input-group-text symbol-smaller-input" id="basic-addon2">{{ symbolTwo }}</span>
                </div>
            </div>
            <div class="input-group mb-3 input-one">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">{{ symbolOne }}</span>
                </div>
                <input ref="text-field-input-one" type="text" v-model="displayValueOne" v-on:blur="focusOutOne" v-on:focus="saveCurrentValueOne" v-on:change="validateValueOne" class="form-control text-field-input" v-bind:class="{'not-entered-input': weeklyRentalIncomeNotEntered}" :placeholder="placeholderOne" :aria-label="placeholderOne" aria-describedby="basic-addon1">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "two-text-fields-with-symbols-version2",
        data () {
          return {
              activeTooltip: false,
              currentValueOne: '',
              currentValueTwo: '',
              activeInputOne: false,
              activeInputTwo: false
          }
        },
        props: {
            name: String,
            valueOne: Number,
            valueTwo: Number,
            placeholderOne: String,
            placeholderTwo: String,
            label: String,
            symbolOne: String,
            symbolTwo: String,
            extraInfo: Number,
            isBoldFont: Boolean,
            hasTooltip: Boolean
        },
        computed: {
            labelPartOne: function () {
                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            toggleLabel: function () {
                return this.label != '';
            },
            fontWeight: function () {
                return this.isBoldFont ? 'bold' : 'normal';
            },
            displayValueOne: {
                get: function () {
                    if (this.activeInputOne) {
                        return this.valueOne;
                    } else {
                        var currencyValue = this.valueOne.toLocaleString('en-US',{useGrouping:true});
                        return currencyValue;
                    }
                },
                set: function (newValue) {
                    this.valueOne = newValue.replace(",", "");
                }
            },
            tooltipText: function () {
                return "This is the amount of money received from a tenant. " +
                    "It can be expressed as a $ amount or a % of the purchase price (i.e. the rental yield). " +
                    "The annual amount is automatically calculated";
            },
            weeklyRentalIncomeNotEntered: function () {
                if (this.label === 'Weekly Rental Income') {
                    return !this.$store.state.weeklyRentalIncomeEntered;
                }

                return false;
            }
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            },
            saveCurrentValueOne: function () {
                if (this.label === 'Weekly Rental Income') {
                    this.$store.commit('weeklyRentalIncomeEntered', true);
                }

                this.$nextTick(() => {
                    this.currentValueOne = this.valueOne;
                    if (this.valueOne === 0) {
                        this.valueOne = '';
                    }
                });

                var valueOneLength = this.valueOne.toString().length;
                var textFieldInput = this.$refs['text-field-input-one'];
                setTimeout(function() {
                    textFieldInput.setSelectionRange(valueOneLength, valueOneLength);
                }, 0);

                this.activeInputOne = true;
            },
            saveCurrentValueTwo: function () {
                this.currentValueTwo = this.valueTwo;

                if (this.valueTwo === 0) {
                    this.valueTwo = '';
                }

                var valueTwoLength = this.valueTwo.toString().length;
                var textFieldInput = this.$refs['text-field-input-two'];
                setTimeout(function() {
                    textFieldInput.setSelectionRange(valueTwoLength, valueTwoLength);
                }, 0);

                this.activeInputTwo = true;
            },
            focusOutOne: function () {

                if (this.valueOne === '') {
                    this.valueOne = 0;
                }

                this.activeInputOne = false;
            },

            focusOutTwo: function () {

                if (this.valueTwo === '') {
                    this.valueTwo = 0;
                }

                this.activeInputTwo = false;
            },
            validateValueOne: function () {

                if (this.valueOne >= 0 && !isNaN(this.valueOne)) {
                    this.valueOne = Math.round(this.valueOne);

                    this.currentValueOne = this.valueOne;
                    this.$emit('calcOne', this.valueOne);
                } else {
                    this.valueOne = this.currentValueOne;
                }
            },
            validateValueTwo: function () {

                if (this.valueTwo >= 0 && !isNaN(this.valueTwo)) {
                    if (Math.floor(this.valueTwo) !== Number(this.valueTwo)) {
                        if (this.valueTwo.toString().split(".")[1].length > 1) {
                            this.valueTwo = Number(Math.round(Number(this.valueTwo+'e'+1))+'e-'+1);
                        }
                    }
                    this.currentValueTwo = this.valueTwo;
                    this.$emit('calcTwo', this.valueTwo);
                } else {
                    this.valueTwo = this.currentValueTwo;
                }
            }
        },
        mounted() {

            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            })
        }
    }
</script>

<style scoped>

    label {
        float: left;
        font-size: 20px;
        color: #465978;
        width: 48% !important;
        margin-top: -7px;
        margin-bottom: -30px;
    }

    #two-inputs {
        display: inline-block;
        width: 50%;
        margin-left: auto;
        float: right;
        clear: right;
    }

    .input-one {
        width: 55%;
        float: right;
        overflow: hidden;
        margin-right: 3px;
    }

    .input-two {
        width: 44%;
        max-width: 75px;
        float: right;
    }

    .input-group-text {
        font-weight: bold;
        background-color: #fff;
        color: #465978;
        padding-left: 4px;
        padding-right: 4px;
        font-size: 18px;
    }

    .input-group-prepend, .input-group-append {
        height: 38px;
    }

    .two-text-fields-with-symbols-version2 {
        width: 85%;
        margin: 0 auto;
    }

    .text-field-input {
        background-color: #fff;
        text-align: right;
        font-size: 20px;
        height: 38px;
        padding-left: 5px;
        padding-right: 5px;
    }

    .input-group {
        height: 38px;
    }

    .symbol-smaller-input {
        padding-left: 4px;
        padding-right: 4px;
        border-left: 0;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -91px;
        left: 0px;
        background-color: #465978;
        height: 90px;
        width: 380px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .not-entered-input {
        background-color: #ffcccc;
        border-width: 2px;
        border-color: #d9534f;
    }

    .extra-info {
        color: #465978;
        font-size: 14px;
        width: 170px;
        margin-left: auto;
    }

    @media (min-width: 768px) and (max-width: 1117px) {
        .input-one {
            margin-right: 1px;
        }
    }

    @media (min-width: 559px) and (max-width: 572px) {
        #two-inputs {
            width: 48%
        }
    }

    @media (max-width: 435px) {
        label {
            margin-top: -3px;
        }

        #two-inputs {
            width: 50%;
        }

        .input-one {
            width: 55%;
            margin-right: 1px;
        }

        .input-two {
            width: 44%;
        }
    }

    @media (max-width: 408px) {
        .calc-tooltip {
            top: -139px;
            height: 138px;
            width: 250px;
        }

        .arrow-down {
            margin-left: 88px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/TwoTextFieldsWithSymbolsVersion2.vue